// Chat Header Component
import { Sparkles, Home, X } from "lucide-react";
import { useLanguage } from "@/i18n";

// Male icon SVG (small)
const MaleIconSmall = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="7" r="4"/>
    <path d="M5.5 21a8.38 8.38 0 0 1 13 0"/>
    <path d="M12 11v4"/>
  </svg>
);

// Female icon SVG (small)
const FemaleIconSmall = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="7" r="4"/>
    <path d="M5.5 21a8.38 8.38 0 0 1 13 0"/>
    <path d="M9 11c0 1.5 1.5 3 3 3s3-1.5 3-3"/>
  </svg>
);

export function ChatHeader({
  activeConversation,
  selectedAssistant,
  selectedCustomAssistant,
  goHome,
  closeConversation
}) {
  const { t } = useLanguage();
  
  if (!activeConversation) return null;

  // Aktif asistan adını al
  const assistantName = selectedCustomAssistant 
    ? selectedCustomAssistant.name 
    : (selectedAssistant === "kaan" ? "Kaan" : "Defne");

  return (
    <div className="chat-header">
      <div className="flex items-center justify-between w-full">
        <div className="flex items-center gap-3">
          {/* Home Button */}
          <button
            onClick={goHome}
            className="w-8 h-8 rounded-lg flex items-center justify-center bg-[var(--bg-tertiary)] hover:bg-[var(--bg-hover)] transition-colors"
            title={t('welcome')}
            data-testid="home-button"
          >
            <Home size={16} className="text-[var(--text-muted)]" />
          </button>
          
          <div className={`w-8 h-8 rounded-lg flex items-center justify-center ${
            selectedCustomAssistant 
              ? "bg-gradient-to-br from-purple-500 to-purple-700" 
              : (selectedAssistant === "kaan" 
                  ? "bg-gradient-to-br from-blue-500 to-blue-700" 
                  : "bg-gradient-to-br from-pink-500 to-purple-600")
          }`}>
            {selectedCustomAssistant ? (
              <Sparkles size={16} color="white" />
            ) : selectedAssistant === "kaan" ? (
              <MaleIconSmall />
            ) : (
              <FemaleIconSmall />
            )}
          </div>
          <div>
            <h2 className="font-medium text-[var(--text-primary)]">{activeConversation.title}</h2>
            <p className="text-xs text-[var(--text-muted)]">
              {t('chatting_with', { name: assistantName })}
            </p>
          </div>
        </div>
        
        {/* Close/X Button */}
        <button
          onClick={closeConversation}
          className="w-8 h-8 rounded-lg flex items-center justify-center bg-[var(--bg-tertiary)] hover:bg-red-500/20 hover:text-red-400 text-[var(--text-muted)] transition-colors"
          title={t('close')}
          data-testid="close-conversation-btn"
        >
          <X size={16} />
        </button>
      </div>
    </div>
  );
}
